import { createAsyncThunk } from '@reduxjs/toolkit';
import TYPES from '../../action-types';
import { navigate } from '../../../helpers/history';

const videoAnalyzingEvent = createAsyncThunk(
  TYPES.ASSETS.VIDEO_ANALYZING_EVENT,
  async (event, {
    extra: {
      sdk, Logger, Toast, localization,
    }, getState,
  }) => {
    const { type, data } = event;
    const modifiedData = { ...data };
    if (type === 'asset.videoAnalyzing.failed') {
      const rejectedAssets = modifiedData.assets?.filter((asset) => asset?.videoAnalyzingErrorCode === 'UnsafeContentError');
      if (rejectedAssets?.length) {
        const { user } = getState();
        Toast(localization.VIDEO_ANALYZING_STATUS_TOAST.UNSAFE_REJECT(), { type: 'error' });
        rejectedAssets.forEach((a) => Logger.log('User', 'VideoIntelligenceSensitiveContentRejected', {
          asset_id: a?._id, file_format: a?.name?.split('.')?.pop(), planName: user?.subscriptionFeatures?.planName, tier_level: user?.addonsFeatures?.videoIntelligence?.title, rejection_reason: a?.videoAnalyzingError,
        }));
      } else {
        Toast('Video analyzing failed', { type: 'error', audit: true });
      }
    }
    if (type === 'asset.videoAnalyzing.complete') {
      if (data.assets.length === 1) {
        const asset = data.assets[0];
        Toast(localization.TRANSCRIPT.TOASTS.videoAnalyzingComplete(asset.name, () => {
          navigate(`/preview/${asset._id}#videoAi`);
        }));
      }
      if (data.assets.length > 1) {
        Toast(localization.TRANSCRIPT.TOASTS.videoAnalyzingCompleteMultiple(data.assets.length));
      }
      /** We need to fetch asset data from the server */
      try {
        const ids = data.assets.map(({ _id }) => _id);
        const { data: response } = await sdk.assets.getMany(ids);

        const assetsById = response.assets.reduce((acc, asset) => ({ ...acc, [asset._id]: asset }), {});

        modifiedData.assets = data.assets.map((asset) => {
          const assetData = assetsById[asset._id];
          if (!assetData) return asset;

          return {
            ...asset,
            keywords: assetData.keywords,
            description: assetData.description,
          };
        });
      } catch (error) {
        Logger.warn('Error fetching assets on videoAnalyzingEvent:', error);
      }
    }
    return {
      ...event,
      data: modifiedData,
    };
  },
);

export default videoAnalyzingEvent;
